"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = exports.ConnectedLanguageSelector = exports.DefaultLanguageSelector = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const spa_core_1 = require("@episerver/spa-core");
const DefaultLanguageSelector = (props) => {
    var _a, _b;
    const repo = (0, spa_core_1.useIContentRepository)();
    const [languages, setLanguages] = (0, react_1.useState)([]);
    const ctx = (0, spa_core_1.useEpiserver)();
    const toFinnish = ((_a = props.labels.inFinnish) === null || _a === void 0 ? void 0 : _a.value) ? props.labels.inFinnish.value : props.labels.inFinnish;
    const toEnglish = ((_b = props.labels.inEnglish) === null || _b === void 0 ? void 0 : _b.value) ? props.labels.inEnglish.value : props.labels.inEnglish;
    // Select language handler
    const selectLanguage = () => {
        const newLang = languages.find(lang => lang.name != props.currentLanguage);
        repo.getByRoute(location.pathname).then((x) => {
            const newPage = x.existingLanguages.find((x) => x.name === newLang.name);
            if (newPage === null || newPage === void 0 ? void 0 : newPage.link) {
                window.location.href = `${newPage.link}${window.location.search}`;
            }
            else {
                window.location.href = ctx.getSpaRoute(newLang.urlSegment);
            }
        });
    };
    // Load the languages
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        repo.getCurrentWebsite().then(x => {
            if (isCancelled)
                return;
            setLanguages(x.languages);
        });
        return () => { isCancelled = true; };
    }, []);
    // We have only two languages.
    return react_1.default.createElement("div", { className: 'col-6 col-md-12 d-flex justify-content-end justify-content-md-start' },
        react_1.default.createElement("button", { lang: props.currentLanguage, suppressHydrationWarning: true, tabIndex: 0, onClick: () => selectLanguage(), className: 'nav-button border-0 px-3 px-md-6 py-3 py-md-2 text-uppercase small-bold d-flex align-items-center' },
            react_1.default.createElement("span", { className: 'icon-language-select text-16 pe-5', "aria-hidden": true }),
            props.currentLanguage === 'en' ? toFinnish : toEnglish));
};
exports.DefaultLanguageSelector = DefaultLanguageSelector;
exports.ConnectedLanguageSelector = (0, react_redux_1.connect)((state) => state.OptiContentCloud || {})(exports.DefaultLanguageSelector);
const LanguageSelector = (props) => {
    const ctx = (0, spa_core_1.useEpiserver)();
    if (ctx.isServerSideRendering())
        return react_1.default.createElement(exports.DefaultLanguageSelector, Object.assign({}, props));
    return react_1.default.createElement(exports.ConnectedLanguageSelector, Object.assign({}, props));
};
exports.LanguageSelector = LanguageSelector;
exports.default = exports.LanguageSelector;
